import React from 'react';
import Icon from '../../../components/AppIcon';

const HISTORICAL = [
  { period: 'January 2025', city: 'All Cities', date: '2025-01-31', highlights: 'Dhaka led with 7.8% YoY growth; Sylhet NRB investment surged 18%' },
  { period: 'December 2024', city: 'All Cities', date: '2024-12-31', highlights: 'Record Q4 transactions in Chittagong; RAJUK Purbachal approvals up 25%' },
  { period: 'November 2024', city: 'All Cities', date: '2024-11-30', highlights: 'Gulshan-Banani premium segment gained 12%; new RAJUK building code updates' },
  { period: 'October 2024', city: 'All Cities', date: '2024-10-31', highlights: 'NRB buying hit 5-year high; UK/US diaspora driving Sylhet villa demand' },
  { period: 'September 2024', city: 'All Cities', date: '2024-09-30', highlights: 'Bashundhara R/A expansion; Chittagong port corridor properties up 9%' },
];

const BDHistoricalReports = ({ onLoadReport }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Archive" size={16} className="text-gray-600" />
        <h3 className="font-semibold text-gray-900 text-sm">Historical Reports Archive</h3>
      </div>
      <div className="space-y-2">
        {HISTORICAL?.map((r, i) => (
          <div key={i} className="flex items-center gap-3 p-3 border border-gray-100 rounded-lg hover:bg-gray-50 transition-colors">
            <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name="FileText" size={14} className="text-gray-500" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-800">{r?.period}</span>
                <span className="text-xs text-gray-400">·</span>
                <span className="text-xs text-gray-500">{r?.city}</span>
              </div>
              <p className="text-xs text-gray-500 truncate mt-0.5">{r?.highlights}</p>
            </div>
            <button
              onClick={() => onLoadReport?.(r)}
              className="text-green-600 hover:text-green-800 text-xs font-medium flex items-center gap-1 flex-shrink-0"
            >
              <Icon name="Eye" size={12} />
              View
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BDHistoricalReports;
